import * as React from 'react';

import type { LegalEntityClient } from '@/api/legal-entity-client';
import { HttpLegalEntityClient } from '@/api/legal-entity-client.http';

// =============================================================================
// legal-entity-client-context.tsx — Injection du LegalEntityClient (DI seam).
// =============================================================================
// AUTO-PORTÉ par la route qui monte l'écran hiérarchie (legal-entity-hierarchy-route.tsx),
// sur le modèle du ParticipationsClientProvider / ClientsClientProvider : le provider enveloppe
// l'écran localement plutôt que de brancher le client dans providers.tsx global (surface partagée
// non touchée — disjonction T7 ∥ T6). Par défaut : l'adaptateur HTTP RÉEL ; les tests injectent
// le StubLegalEntityClient via le provider.

const defaultLegalEntityClient: LegalEntityClient = new HttpLegalEntityClient();

const LegalEntityClientContext = React.createContext<LegalEntityClient>(
  defaultLegalEntityClient,
);

export interface LegalEntityClientProviderProps {
  client?: LegalEntityClient | undefined;
  children: React.ReactNode;
}

export function LegalEntityClientProvider({
  client = defaultLegalEntityClient,
  children,
}: LegalEntityClientProviderProps): React.JSX.Element {
  return (
    <LegalEntityClientContext.Provider value={client}>
      {children}
    </LegalEntityClientContext.Provider>
  );
}

export function useLegalEntityClient(): LegalEntityClient {
  return React.useContext(LegalEntityClientContext);
}
